/**
 * How a code door's object is named wherever it is shown: the object, and its
 * location when there is one. Three surfaces spelled this out inline — the
 * form dialog's fixed-object line, its asset picker, and the confirm dialog —
 * which is three chances for them to drift apart.
 */
export const formatCodeDoorLabel = (
    name: string | null | undefined,
    locationName: string | null | undefined,
    fallback: string,
): string => {
    const object = name?.trim() || fallback;
    const location = locationName?.trim();
    return location ? `${object} — ${location}` : object;
};
